export default __webpack_public_path__ + "china.28ebcc11.png";